// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"83c5d930","64":"8804170e","116":"db0d95e2","472":"8b6ca1ef","626":"f625ec6c","786":"59ff8b0b"}[chunkId] + ".chunk.js";
};